/* Custom hero behaviour.

   MULTI-OPTION. Selection state is an array of chosen values, one per option
   index. A variant matches when every one of its option values matches.

   SPLIT CLASP. Unique strands carry one option holding metal and style
   together. The metal pills are a filter, not an option of their own: they
   set which tiles are visible and re-pick the same style in the new metal.
   The real option value is still whatever tile ends up selected.

   THE SPEC GRID IS A DIFFERENT SECTION. Rows that follow the variant carry
   data-ppd-optout and are updated from here.

   MONEY FORMATTING must match Liquid's money filter exactly.

   TWO WAYS THE GALLERY FOLLOWS THE SELECTION, tried in this order.

   1. data-ppdh-for on a slide. Unique strands photograph the fitted clasp, so
      a slide can be tagged for a metal and switched to directly.

   2. The variant's own featured image. Stocked pieces are photographed once
      per metal and each variant carries that image, but the variants JSON in
      this section does not include it. Rather than widen that payload for
      every product, the map is fetched once from /products/<handle>.js on the
      first selection that needs it, then cached. Nothing is fetched on a page
      where route 1 already works, and a failed fetch leaves the gallery where
      it is rather than breaking the picker.

   Slides are matched on FILENAME, not the whole URL, because the stage and
   the product endpoint return different size and version parameters for the
   same image. */

(function () {
  var root = document.querySelector('[data-ppdh]');
  if (!root) return;
  if (root.getAttribute('data-ppdh-ready') === '1') return;
  root.setAttribute('data-ppdh-ready', '1');

  /* ---------- gallery ---------- */
  var items = root.querySelectorAll('[data-ppdh-item]');
  var thumbs = root.querySelectorAll('[data-ppdh-thumb]');
  function showShot(i) {
    for (var a = 0; a < items.length; a++) {
      items[a].classList.toggle('is-on', a === i);
      var v = items[a].querySelector('video');
      if (v && a !== i) { try { v.pause(); } catch (e) {} }
    }
    for (var b = 0; b < thumbs.length; b++) {
      thumbs[b].setAttribute('aria-current', b === i ? 'true' : 'false');
    }
  }
  for (var t = 0; t < thumbs.length; t++) {
    (function (i) { thumbs[i].addEventListener('click', function () { showShot(i); }); })(t);
  }

  /* Returns true when a slide was tagged for this metal and shown. */
  function showMetal(metal) {
    if (!metal) return false;
    for (var s = 0; s < items.length; s++) {
      if (items[s].getAttribute('data-ppdh-for') === metal) { showShot(s); return true; }
    }
    return false;
  }

  /* ---------- variant featured image, fetched on demand ---------- */
  var vmap = null;

  function fileOf(u) {
    return String(u || '').split('?')[0].split('/').pop();
  }

  function withMap(cb) {
    if (vmap) { cb(); return; }
    var parts = window.location.pathname.split('/products/');
    if (parts.length < 2) { vmap = {}; cb(); return; }
    var handle = parts[1].split('?')[0].split('/')[0];
    if (!handle || !window.fetch) { vmap = {}; cb(); return; }

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        vmap = {};
        var vs = (p && p.variants) || [];
        for (var i = 0; i < vs.length; i++) {
          if (vs[i].featured_image && vs[i].featured_image.src) {
            vmap[vs[i].id] = fileOf(vs[i].featured_image.src);
          }
        }
        cb();
      })
      .catch(function () { vmap = {}; });
  }

  function showVariantImage(v) {
    if (!v) return;
    withMap(function () {
      var want = vmap[v.id];
      if (!want) return;
      var stage = root.querySelectorAll('[data-ppdh-full]');
      for (var i = 0; i < stage.length; i++) {
        var src = stage[i].getAttribute('data-ppdh-full') || stage[i].getAttribute('src') || '';
        if (fileOf(src) !== want) continue;
        var slide = stage[i].closest ? stage[i].closest('[data-ppdh-item]') : null;
        var at = slide ? Array.prototype.indexOf.call(items, slide) : i;
        if (at > -1) showShot(at);
        return;
      }
    });
  }

  /* ---------- variants ---------- */
  var dataEl = root.querySelector('[data-ppdh-variants]');
  var variants = [];
  if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

  var idInput = root.querySelector('[data-ppdh-id]');
  var priceEl = root.querySelector('[data-ppdh-price]');
  var skuEl   = root.querySelector('[data-ppdh-sku]');
  var cta     = root.querySelector('[data-ppdh-cta]');
  var fmt     = root.getAttribute('data-money-format') || '${{amount}}';

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, n);
  }

  var groups = [].slice.call(root.querySelectorAll('[data-ppdh-opt]'));
  var chosen = groups.map(function (g) {
    var on = g.querySelector('[aria-pressed="true"]');
    return on ? on.getAttribute('data-ppdh-val') : null;
  });

  function findVariant() {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < chosen.length; j++) {
        if (chosen[j] !== null && v.opts[j] !== chosen[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function paint() {
    var v = findVariant();

    groups.forEach(function (g, gi) {
      var val = chosen[gi] || '';
      var out = root.querySelector('[data-ppdh-chosen="' + gi + '"]');
      if (out) out.textContent = val;

      var name = g.getAttribute('data-ppdh-optname');
      if (name) {
        var spec = document.querySelector('[data-ppd-optout="' + name.replace(/"/g, '') + '"]');
        if (spec) spec.textContent = val;
      }
    });

    if (!v) {
      if (cta) { cta.disabled = true; cta.textContent = 'Unavailable'; }
      return null;
    }
    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.innerHTML = money(v.price);
    if (skuEl && v.sku) skuEl.textContent = v.sku;
    if (cta) {
      cta.disabled = !v.available;
      cta.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    return v;
  }

  function selectButton(g, gi, b) {
    chosen[gi] = b.getAttribute('data-ppdh-val');
    g.querySelectorAll('[data-ppdh-val]').forEach(function (x) {
      x.setAttribute('aria-pressed', String(x === b));
    });
    var tagged = showMetal(b.getAttribute('data-ppdh-metal'));
    var v = paint();
    if (!tagged) showVariantImage(v);
  }

  groups.forEach(function (g, gi) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ppdh-val]');
      if (!b || b.disabled) return;
      selectButton(g, gi, b);
    });
  });

  /* ---------- split clasp: metal pills filter the tiles ---------- */
  var filterBar = root.querySelector('[data-ppdh-metalfilter]');
  if (filterBar) {
    var claspGroup = root.querySelector('[data-ppdh-showmetal]');
    var claspIndex = groups.indexOf(claspGroup);

    filterBar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ppdh-setmetal]');
      if (!b || !claspGroup) return;
      var metal = b.getAttribute('data-ppdh-setmetal');

      filterBar.querySelectorAll('[data-ppdh-setmetal]').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      claspGroup.setAttribute('data-ppdh-showmetal', metal);

      /* keep the style the customer already picked, in the new metal */
      var currentBtn = claspGroup.querySelector('[aria-pressed="true"]');
      var style = currentBtn ? currentBtn.getAttribute('data-ppdh-style') : null;
      var next = null;
      var tiles = claspGroup.querySelectorAll('[data-ppdh-val]');
      for (var i = 0; i < tiles.length; i++) {
        if (tiles[i].getAttribute('data-ppdh-metal') !== metal) continue;
        if (!next) next = tiles[i];
        if (style && tiles[i].getAttribute('data-ppdh-style') === style) { next = tiles[i]; break; }
      }
      if (next && claspIndex > -1) selectButton(claspGroup, claspIndex, next);
      else showMetal(metal);
    });
  }

  paint();

  /* ---------- lightbox ---------- */
  var lb = document.querySelector('[data-ppdh-lb]');
  if (!lb) return;
  var img = lb.querySelector('[data-ppdh-lbimg]');
  var cap = lb.querySelector('[data-ppdh-lbcap]');
  var count = lb.querySelector('[data-ppdh-lbcount]');
  var stageImgs = root.querySelectorAll('[data-ppdh-full]');
  if (!stageImgs.length) return;

  var shots = [];
  for (var i2 = 0; i2 < stageImgs.length; i2++) {
    shots.push({ src: stageImgs[i2].getAttribute('data-ppdh-full'), alt: stageImgs[i2].getAttribute('alt') || '' });
  }

  var idx = 0, zoomed = false;
  function unzoom() {
    zoomed = false;
    img.classList.remove('is-zoom');
    img.style.transform = 'scale(1)';
    img.style.transformOrigin = 'center center';
  }
  function paintLb() {
    unzoom();
    img.src = shots[idx].src;
    img.alt = shots[idx].alt;
    if (cap) cap.textContent = shots[idx].alt;
    if (count) count.textContent = (idx + 1) + ' / ' + shots.length;
  }
  function open(i) { idx = i || 0; lb.classList.add('is-on'); document.body.style.overflow = 'hidden'; paintLb(); }
  function close() { lb.classList.remove('is-on'); document.body.style.overflow = ''; unzoom(); }
  function step(d) { idx = (idx + d + shots.length) % shots.length; paintLb(); showShot(idx); }

  for (var s2 = 0; s2 < stageImgs.length; s2++) {
    (function (i) { stageImgs[i].addEventListener('click', function () { open(i); }); })(s2);
  }
  img.addEventListener('click', function (e) {
    e.stopPropagation();
    if (zoomed) { unzoom(); return; }
    zoomed = true; img.classList.add('is-zoom');
    var r = img.getBoundingClientRect();
    img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    img.style.transform = 'scale(2.6)';
  });
  img.addEventListener('mousemove', function (e) {
    if (!zoomed) return;
    var r = img.getBoundingClientRect();
    img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
  });
  lb.querySelector('[data-ppdh-lbclose]').addEventListener('click', close);
  lb.querySelector('[data-ppdh-lbprev]').addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
  lb.querySelector('[data-ppdh-lbnext]').addEventListener('click', function (e) { e.stopPropagation(); step(1); });
  lb.addEventListener('click', function (e) {
    if (e.target === lb || e.target.hasAttribute('data-ppdh-lbstage')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (!lb.classList.contains('is-on')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') step(-1);
    else if (e.key === 'ArrowRight') step(1);
  });
})();
